
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { colors, Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";
import { GetTransform } from "./RefTransformationFunctions";


const ArcBarHorizontalProportion = (props) => {
    const safeParse = (str) => {
        try {
            JSON.parse(str)
            return true
        } catch {
            return false;
        }
    }
    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, MaxValue, Label, Color, Proportion, DataLabels, ValueOrder, ValueLabels, Transform } = ComponentProperties
    const DataReportData = props.DataReportData
    const KeyToUseArray = KeyToUse ? KeyToUse.split('|') : []
    const DataLabelArray = DataLabels ? DataLabels.split('|') : []

    const ValueLabelJSON = safeParse(ValueLabels) ? JSON.parse(ValueLabels) : {}
    const ValueOrderArray = (ValueOrder && ValueOrder.length > 0 && ValueOrder.split('|')) || []
    const Colors = GetColor("RAINBOW SET", 0)

    //for each column defined
    const ValueArrayFinal = KeyToUseArray.map((ky, i) => {
        // get array of values to use
        const ValueArray = DataReportData.map(x => { return { [ky]: Transform ? GetTransform(Transform, x[ky]) : x[ky] } })
        // chart js requires a specific setup.
        // convert into {key: "COVID_SHOT", values:[{distribution: "YES", value:700, percentage:70},{distribution: "NO", value:300, percentage:30}]}
        const ArcSumOfValues =
            _.chain(ValueArray)
                .groupBy(ky)
                .map((value, key) => (
                    {
                        distribution: key
                        , value: value.length
                        , percentage: Number(parseFloat((value.length / ValueArray.length * 100)).toFixed(2))
                        , order: ValueOrderArray.indexOf(key) >= 0 ? ValueOrderArray.indexOf(key) : 99
                    }))
                .value()
        const ArcSorted = _.sortBy(ArcSumOfValues, 'order')

        const Labels = ArcSorted.map((s, i) => { return (ValueLabelJSON && ValueLabelJSON[s.distribution]) ? ValueLabelJSON[s.distribution] : s.distribution + " (" + s.percentage + "%)" })

        // convert into [{data:{labels:["COVID_SHOT"], datasets:[{label:"YES", data:[70]},{label:"NO", data:[30]}]},options:{...}}]
        const data = {
            labels: [DataLabelArray[i]]
            , datasets: ArcSorted.map((x, i) => {
                return {
                    label: Labels[i]
                    , data: [Number(parseFloat((x.value)).toFixed(2))]
                    , barThickness: 8
                    , backgroundColor: Color ? GetColor(Color, Number(x.distribution)) : Colors[i]
                }
            })
        }


        const options = {
            responsive: true,
            maintainAspectRatio: false,
            indexAxis: 'y',
            scales: {
                y: {
                    stacked: true,
                    max: Proportion ? 100 : ValueArray.length,
                    beginAtZero: true,
                    grid: {
                        display: false,
                        drawBorder: false
                    },
                    ticks: {
                        display: true
                    }
                },
                x: {
                    stacked: true,
                    max: Proportion ? 100 : ValueArray.length,
                    grid: {
                        display: false,
                        drawBorder: false
                    },
                    ticks: {
                        display: false
                    }
                }
            },
            plugins: {
                legend: {
                    display: false,
                    position: "bottom"
                },


            }

        }
        return { data: data, options: options }
    })





    return (
        <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={1}>
            {Label && (

                <Grid item xs={12}>
                    <Typography variant="h6" align="center">{Label}</Typography>
                </Grid>
            )}
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={1}>
                    {ValueArrayFinal.map(grph => {
                        return (
                            <Grid item xs={12}>
                                <Bar data={grph.data} options={grph.options} height={"50px"} width="100%" />
                            </Grid>
                        )
                    })}
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ArcBarHorizontalProportion